import { instanceBo } from "../utils/axios.create";
import {
	SettingManagement,
	CreateSettingPayload,
	UpdateSettingPayload,
} from "../domain/settings.interface";

const findAll = async (
	selectedAccountId?: string,
): Promise<SettingManagement[]> => {
	const queryParam = selectedAccountId
		? `?application=backoffice&selectedAccountId=${selectedAccountId}`
		: "?application=backoffice";

	return instanceBo
		.get(`/settings/admin${queryParam}`)
		.then((res) => res.data.body)
		.catch((err) => Promise.reject(err.response.data));
};

const create = async (
	data: CreateSettingPayload,
): Promise<SettingManagement> => {
	return instanceBo
		.post("/settings/admin", data)
		.then((res) => res.data.body)
		.catch((err) => Promise.reject(err.response.data));
};

const update = async (
	settingId: string,
	data: UpdateSettingPayload,
): Promise<SettingManagement> => {
	return instanceBo
		.put(`/settings/admin/${settingId}`, data)
		.then((res) => res.data.body)
		.catch((err) => Promise.reject(err.response.data));
};

const remove = async (settingId: string): Promise<void> => {
	return instanceBo
		.delete(`/settings/admin/${settingId}`)
		.then((res) => res.data)
		.catch((err) => Promise.reject(err.response.data));
};

export const settingsManagementService = {
	findAll,
	create,
	update,
	remove,
};
